(() => {
  const NS = 'http://www.w3.org/2000/svg';
  const gearPath = 'M19.61 9.53 L22.67 10.31 L22.67 13.69 L19.61 14.47 L19.13 15.63 L20.74 18.35 L18.35 20.74 L15.63 19.13 L14.47 19.61 L13.69 22.67 L10.31 22.67 L9.53 19.61 L8.37 19.13 L5.65 20.74 L3.26 18.35 L4.87 15.63 L4.39 14.47 L1.33 13.69 L1.33 10.31 L4.39 9.53 L4.87 8.37 L3.26 5.65 L5.65 3.26 L8.37 4.87 L9.53 4.39 L10.31 1.33 L13.69 1.33 L14.47 4.39 L15.63 4.87 L18.35 3.26 L20.74 5.65 L19.13 8.37 Z';
  // Coordinates refer only to visible punctuation, never to covered lettering or people.
  const artwork = {
    'ebd-blue-kids.webp': { width: 1200, height: 800, patches: [[503,450,36,42,562,500],[562,638,36,40,558,568]], marks: [[529,471,1.8],[586.5,658.5,1.7]], color: '#080c0b' },
    'ebd-blue-scary.webp': { width: 1200, height: 800, patches: [[541,629,49,52,590,646]], marks: [[574,655,2]], color: '#0a0c0c' },
    'ebd-blue-flame.webp': { width: 1200, height: 800, patches: [[551,660,45,46,551,616]], marks: [[577,683,2]], color: '#0e1011' },
    'ebd-blue-realtree.webp': { width: 1200, height: 800, patches: [[609,565,18,18,605,584]], marks: [[617,574,.7]], color: '#0e100f' },
    'ebd-blue-pink.webp': { width: 1200, height: 800, patches: [[634,487,26,28,496,366]], marks: [[650,500.5,1]], color: '#101719' },
    'ebd-blue-vest-cover-mobile.webp': { width: 1080, height: 1440, patches: [[788,313,42,45,661,356]], marks: [[817,335,2.1],[337,1298,.36,'#e4f500'],[535,1298,.36,'#e4f500']], color: '#101719' },
    'ebd-blue-vest-cover-desktop.webp': { width: 2400, height: 1200, patches: [[660,771,24,26,660,898]], marks: [[677,784,1],[388,1164.5,.34,'#e4f500'],[606,1164.5,.34,'#e4f500']], color: '#101719' }
  };
  function svgElement(name, attributes) {
    const node = document.createElementNS(NS, name);
    Object.entries(attributes).forEach(([key,value]) => node.setAttribute(key,String(value)));
    return node;
  }
  function mark() {
    const svg = svgElement('svg', { viewBox: '0 0 24 24', 'aria-hidden': 'true', focusable: 'false' });
    svg.append(svgElement('path', { d: gearPath, fill: 'currentColor' }));
    return svg;
  }
  function punctuate(root) {
    root.querySelectorAll('main h1,main h2,main h3,.eb-editorial-title,.eb-editorial-line,.eb-editorial-strip>span,.eb-blue-quote').forEach(heading => {
      if (!/Anton|Impact/i.test(getComputedStyle(heading).fontFamily) && !heading.matches('.eb-editorial-strip>span')) return;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.textContent.includes('.') && !node.parentElement.closest('.eh-gear-period,.eh-sr-only,.ebd-gear-stop,script,style,svg') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        const parts = node.textContent.split('.');
        parts.forEach((part,index) => {
          if (index) {
            const stop = document.createElement('span');
            stop.className = 'ebd-gear-stop';
            const dot = document.createElement('span');
            dot.className = 'ebd-gear-stop-original';
            dot.textContent = '.';
            stop.append(dot, mark());
            fragment.append(stop);
          }
          fragment.append(document.createTextNode(part));
        });
        node.replaceWith(fragment);
      });
    });
  }
  function decorateArtwork(img) {
    const filename = (img.currentSrc || img.src).split('/').pop().split('?')[0];
    const data = artwork[filename];
    if (!data) return;
    let wrapper = img.closest('.ebd-gear-artwork');
    if (!wrapper) {
      const original = img.parentElement.tagName === 'PICTURE' ? img.parentElement : img;
      wrapper = document.createElement('span');
      wrapper.className = 'ebd-gear-artwork';
      original.before(wrapper);
      wrapper.append(original);
    }
    if (wrapper.dataset.gearArtwork === filename) return;
    wrapper.querySelector('.ebd-gear-artwork-overlay')?.remove();
    wrapper.dataset.gearArtwork = filename;
    const overlay = svgElement('svg', { class: 'ebd-gear-artwork-overlay', viewBox: `0 0 ${data.width} ${data.height}`, preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true', focusable: 'false' });
    (data.patches || []).forEach(([x,y,width,height,sourceX,sourceY]) => {
      const patch = svgElement('svg', { x, y, width, height, viewBox: `${sourceX} ${sourceY} ${width} ${height}`, overflow: 'hidden' });
      patch.append(svgElement('image', { href: img.currentSrc || img.src, width: data.width, height: data.height }));
      overlay.append(patch);
    });
    data.marks.forEach(([x,y,scale,color]) => overlay.append(svgElement('path', {
      d: gearPath, fill: color || data.color,
      transform: `translate(${x + scale * 8} ${y}) scale(${scale}) translate(-12 -12)`
    })));
    wrapper.append(overlay);
  }
  function mount(root = document) {
    punctuate(root);
    root.querySelectorAll('main img').forEach(img => {
      const sources = [img.src, ...Array.from(img.parentElement.querySelectorAll('source')).map(source => source.srcset)].join(' ');
      if (!Object.keys(artwork).some(filename => sources.includes(filename))) return;
      decorateArtwork(img);
      if (!img.dataset.gearListening) {
        img.dataset.gearListening = 'true';
        img.addEventListener('load', () => decorateArtwork(img));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
